import * as Yup from 'yup';

import { combineSchemas } from 'common/utils';
import { Fields, SelectOption, StatusOption } from 'common/types';
import { STATUSES_OPTIONS } from 'common/consts';

export type BlogFields = {
  title: string;
  description: string;
  url: string;
  image_url: string;
  status: StatusOption[];
  is_featured: boolean;
  is_inspiration: boolean;
};

export const CLEAR_FORM_VALUES: BlogFields = {
  title: '',
  description: '',
  url: '',
  image_url: '',
  status: [STATUSES_OPTIONS[0]],
  is_featured: false,
  is_inspiration: false,
};

export const fields: Fields<BlogFields> = {
  title: {
    label: 'Blog title',
    name: 'title',
    schema: Yup.string().required(),
  },
  description: {
    label: 'Blog description',
    name: 'description',
    schema: Yup.string().required(),
  },
  url: {
    label: 'Blog url',
    name: 'url',
    schema: Yup.string().url().required(),
  },
  image_url: {
    label: 'Blog image url',
    name: 'image_url',
    schema: Yup.string().url().required(),
  },
  status: {
    label: 'Status',
    name: 'status',
    schema: Yup.array().required(),
  },
  is_featured: {
    label: 'Is this content featured?',
    name: 'is_featured',
  },
  is_inspiration: {
    label: 'Is this content an inspiration?',
    name: 'is_inspiration',
  },
};

export const validationSchema = Yup.object().shape<BlogFields>(combineSchemas(fields));

export type BlogTagsFields = {
  category: SelectOption<string>[];
  subcategory: SelectOption<string>[];
  habit: SelectOption<string>[];
  habit_replacement: SelectOption<string>;
  season: SelectOption<string>[];
  minutes_to_read: SelectOption<number>;
  gender: SelectOption<string>;
};

export const tagsFields: Fields<BlogTagsFields> = {
  category: {
    label: 'Category',
    name: 'category',
    schema: Yup.array().nullable(),
  },
  subcategory: {
    label: 'Subcategory',
    name: 'subcategory',
    schema: Yup.array().nullable(),
  },
  habit: {
    label: 'Habit',
    name: 'habit',
    schema: Yup.array().nullable(),
  },
  habit_replacement: {
    label: 'Habit replacement',
    name: 'habit_replacement',
    schema: Yup.array().nullable(),
  },
  season: {
    label: 'Season',
    name: 'season',
    schema: Yup.array().nullable(),
  },
  minutes_to_read: {
    label: 'Minutes to read',
    name: 'minutes_to_read',
    schema: Yup.number()
      .transform((value) => (isNaN(value) ? null : value))
      .nullable()
      .test('Is positive?', 'Minutes to read must be greater than 0.', (value) => {
        return typeof value === 'object' || (typeof value === 'number' && value > 0);
      }),
  },
  gender: {
    label: 'Gender',
    name: 'gender',
    schema: Yup.array().nullable(),
  },
};

export const blogTagsValidationSchema = Yup.object().shape<BlogTagsFields>(
  combineSchemas(tagsFields),
);
